import Vue from "vue";

Vue.filter("dataFilter", function(input) {
  var d = new Date(input);
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  var day = d.getDate() < 10 ? "0" + d.getDate() : "" + d.getDate();
  var hour = d.getHours();
  var minutes = d.getMinutes();
  var seconds = d.getSeconds();
  return (
    year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds
  );
});

Vue.filter("repayTypeFilter", input => {
  switch (input) {
    case 1:
      return "按期付息，到期还本";
      break;
    case 2:
      return "一次性还本付息";
      break;
    case 3:
      return "等额本息";
      break;
  }
});
// relationship 关系  100:父母,200:配偶,300:子女,400:兄弟姐妹,600:亲属,700:同事,800:朋友,900:其他

Vue.filter("relationshipFilter", input => {
  switch (input) {
    case "100":
      return "父母";
      break;
    case "200":
      return "配偶";
      break;
    case "300":
      return "子女";
      break;
    case "400":
      return "兄弟姐妹";
      break;
    case "600":
      return "亲属";
      break;
    case "700":
      return "同事";
      break;
    case "800":
      return "朋友";
      break;
    case "900":
      return "其他";
      break;
  }
});
Vue.filter("positionFilter", input => {
  switch (input) {
    case 1:
      return "管理、技术、行政岗位";
      break;
    case 2:
      return "销售岗位";
      break;
    case 3:
      return "其他基层服务岗位";
      break;
  }
});

Vue.filter("monthlyIncomeFilter", input => {
  switch (input) {
    case 1:
      return "5000元以下";
      break;
    case 2:
      return "5000-10000元";
      break;
    case 3:
      return "10000-20000元";
      break;
    case 4:
      return "20000-30000元";
      break;
    case 5:
      return "30000元以上";
      break;
    case 6:
      return "30000元以上";
      break;
  }
});

Vue.filter("termUnitFilter", input => {
  switch (input) {
    case 1:
      return "天";
      break;
    case 2:
      return "周";
      break;
    case 3:
      return "个月";
      break;
    case 4:
      return "年";
      break;
  }
});
Vue.filter("loanTypeFilter", input => {
  switch (input) {
    case 1:
      return "企业经营贷";
      break;
    case 2:
      return "房产抵押贷";
      break;
    case 3:
      return "企业周转贷";
      break;
    case 4:
      return "企业融租贷";
      break;
    case 5:
      return "供应链金融";
      break;
    case 6:
      return "供应链金融贷";
      break;
    case 7:
      return "个人消费贷";
      break;  
  }

});

// 已参与的活动  ：0：无，1：一马当先奖，3：一马当先奖+最高投资奖，5：一马当先奖+完美收官奖，6：最高投资奖+完美收官奖，7：一马当先奖+最高投资奖+完美收官奖
Vue.filter("activitySwiftFilter", input => {
  switch (input) {
    case 0:
      return "无";
      break;
    case 1:
      return "一马当先奖";
      break;
    case 3:
      return "一马当先奖+最高投资奖";
      break;
    case 5:
      return "一马当先奖+完美收官奖";
      break;
    case 6:
      return "最高投资奖+完美收官奖";
      break;
    case 7:
      return "一马当先奖+最高投资奖+完美收官奖";
      break;
  }

});

// "1,短期周转","2,购房借款","3,购车借款","4,装修借款","5,投资创业","6,个人消费","7,其他借款"

Vue.filter("borrowTypeFilter", input => {
  switch (input) {
    case 1:
      return "短期周转";
      break;
    case 2:
      return "购房借款";
      break;
    case 3:
      return "购车借款";
      break;
    case 4:
      return "装修借款";
      break;
    case 5:
      return "投资创业";
      break;
    case 6:
      return "个人消费";
      break;
    case 7:
      return "其他借款";
      break;
  }
});

Vue.filter("date", input => {
  var d = new Date(input);
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  var day = d.getDate() < 10 ? "0" + d.getDate() : "" + d.getDate();
  var hour = d.getHours();
  var minutes = d.getMinutes();
  var seconds = d.getSeconds();
  return (
    year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds
  );
});

Vue.filter("officeTypeFilter", input => {
  // （1 :机关事业单位,2:国营,3:民营,4:三资企业,5:其他）
  switch (input) {
    case 1:
      return "机关事业单位";
      break;
    case 2:
      return "国营";
      break;
    case 3:
      return "民营";
      break;
    case 4:
      return "三资企业";
      break;
    case 5:
      return "其他";
      break;
  }
});
Vue.filter("industryFilter", input => {
  //  1、制造业
  // 2、农、林、牧、渔业
  // 3、建筑业
  // 4、信息传输、计算机服务和软件业
  // 5、金融业
  // 6、文化、体育和娱乐业
  // 7、教育
  // 8、租赁和商务服务
  // 9、其他
  switch (input) {
    case 1:
      return "制造业";
      break;
    case 2:
      return "农、林、牧、渔业";
      break;
    case 3:
      return "建筑业";
      break;
    case 4:
      return "信息传输、计算机服务和软件业";
      break;
    case 5:
      return "金融业";
      break;
    case 6:
      return "文化、体育和娱乐业";
      break;
    case 7:
      return "教育";
      break;
    case 8:
      return "租赁和商务服务";
      break;
    case 9:
      return "其他";
      break;
  }
});

Vue.filter("shareholdingRatioFilter", input => {
  // （1：50%及以上;2：40%-<50%;3：30%-<40%;4：20%-<30%）
  switch (input) {
    case 1:
      return "50%及以上";
      break;
    case 2:
      return "40%-<50%";
      break;
    case 3:
      return "30%-<40%";
      break;
    case 4:
      return "20%-<30%";
      break;
  }
});

Vue.filter("businessLifeFilter", input => {
  // 1：10年（含）以上;2：6-9年;3：3-5年;4：2年以下）
  switch (input) {
    case 1:
      return "10年（含）以上";
      break;
    case 2:
      return "6-9年";
      break;
    case 3:
      return "3-5年";
      break;
    case 4:
      return "2年以下";
      break;
  }
});

Vue.filter("housingStateFilter", input => {
  //1.“贷款购置房屋”，应该填写“房贷”、“面积”；2.“自购房屋，无房贷”；3.“租房”，应该填写“房租”
  switch (input) {
    case 1:
      return "贷款购置房屋”，应该填写“房贷”、“面积";
      break;
    case 2:
      return "自购房屋，无房贷";
      break;
    case 3:
      return "租房";
      break;
  }
});

Vue.filter("eduFilter", input => {
  // 10,20...90分别表示小学，初中，中专，高中，大专，本科，硕士，博士，其它
  switch (input) {
    case 10:
      return "小学";
      break;
    case 20:
      return "初中";
      break;
    case 30:
      return "中专";
      break;
    case 40:
      return "高中";
      break;
    case 50:
      return "大专";
      break;
    case 60:
      return "本科";
      break;
    case 70:
      return "硕士";
      break;
    case 80:
      return "博士";
      break;
    case 90:
      return "其它";
      break;
  }
});

Vue.filter("houseFilter", input => {
  //  {       "1": "普通商品房",       "2": "经济适用房",       "3": "别墅",       "4": "商铺",       "5": "厂房",       "6": "小产权房",       "7": "可上市公房",       "8": "央产房",       "9": "其他"     },
  switch (input) {
    case 1:
      return "普通商品房";
      break;
    case 2:
      return "经济适用房";
      break;
    case 3:
      return "别墅";
      break;
    case 4:
      return "商铺";
      break;
    case 5:
      return "厂房";
      break;
    case 6:
      return "小产权房";
      break;
    case 7:
      return "可上市公房";
      break;
    case 8:
      return "央产房";
      break;
    case 9:
      return "其它";
      break;
  }
});

Vue.filter("stateFilter", input => {
  //  {       "100": "初始",       "200": "通过",       "300": "拒绝",        },
  switch (input) {
    case 100:
      return "初始";
      break;
    case 200:
      return "通过";
      break;
    case 300:
      return "拒绝";
  }
});

Vue.filter("typeFilter", input => {
  // 1：房产证  2：车辆  3：身份证明: 4：企业证照 0：其他
  switch (input) {
    case 1:
      return "房产证";
      break;
    case 2:
      return "车辆";
      break;
    case 3:
      return "身份证明";
    case 4:
      return "企业证照";
    case 0:
      return "其他";
  }
});
Vue.filter("statusFilter", input => {
  //申请提交:100,审核中:150,处理完毕(审核通过):200,处理完毕(审核中):300,处理完毕(银行退回):400,处理中:500)
  if (input == 100) {
    return "申请提交";
  } else if (input == 150) {
    return "审核中";
  } else if (input == 200) {
    return "处理完毕(审核通过)";
  } else if (input == 300) {
    return "处理完毕(审核中)";
  } else if (input == 400) {
    return "处理完毕(银行退回)";
  } else if (input == 500) {
    return "处理中";
  }
});
Vue.filter("loanFilter", input => {
  // 0：普通标  1新手标  2：vip标 3：周周升标 
  switch (input) {
    case 0:
      return "普通标";
    case 1:
      return "新手标";
    case 2:
      return "vip标";
    case 3:
      return "周周升";
    case 4:
      return "安选投";
    case 5:
      return "预约投";
    case '其他':
      return "其他类型";    
   
  }
});
Vue.filter("couponStateFilter", input => {
  // 0：未使用；1： 已过期；2：已使用
  switch (input) {
    case 0:
      return "未使用";
    case 1:
      return "已过期";
    case 2:
      return "已使用";
   
  }
});


Vue.filter("couponTypeFilter", input => {
  //类型（1：现金券；2：加息券）
  switch (input) {
    case 1:
      return "现金券";
    case 2:
      return "加息券";
   
  }
});




Vue.filter("bannerTypeFilter", input => {
 // type  类型(0-4，分别：网站，微信，苹果，安卓，其他)
  switch (input) {
    case 0:
      return "网站";
    case 1:
      return "微信";
    case 2:
      return "苹果";
    case 3:
      return "安卓";
    default:
      return "其他";  
   
  }
});


Vue.filter("queryReasonFilter", input => {
 
   switch (input) {
     
     case "1":
       return "授信审批";
     case "2":
       return "贷中管理";
     case "3":
       return "贷后管理";
     case "4":
       return "个人查询";
     case "5":
       return "异议处理";
     case "6":
       return "担保查询";
    
    
   }
 });
 Vue.filter("gradeFilter", input => {
 
  switch (input) {
    
    case "1":
      return "普卡";
    case "2":
      return "铜卡";
    case "3":
      return "银卡";
    case "4":
      return "金卡";
    case "5":
      return "白金卡";
    case "6":
      return "钻石卡";
      case "7":
      return "黑钻卡";
   
   
  }
});


// showType  展示类型（1：主页banner，2：活动推荐banner,3:闪屏广告 4：弹窗广告 5:浮框活动 ）



// WEBPACK FOOTER //
// ./src/filter.js